import {Directive, ElementRef, HostListener} from '@angular/core';

import * as screenfull from 'screenfull';

@Directive({
  selector: '[appToggleFullScreen]'
})
export class ToggleFullScreenDirective {
  constructor(private _Elements: ElementRef) {}

  @HostListener('click')
  _OnClick() {
    if (screenfull.isEnabled) {
      (this._Elements).nativeElement.querySelector('.feather').classList.toggle('icon-maximize');
      (this._Elements).nativeElement.querySelector('.feather').classList.toggle('icon-minimize');
      screenfull.toggle();
    }
  }
}
